import { useContext, useEffect, useRef, useState } from 'react'
import { media } from '../../../dataSets/media';
import { updateDataComplex } from '../../../firebase/firebase_functions';
import { AppContext } from '../../../contextApi/ContextApi';

export default function ProfileDetailSection({label, id, value, updateParam}) {
    const {currentUser, currentWebsite, setToastMessage, messagesOptions, setCurrentUser} = useContext(AppContext);
    const [isEdit, setIsEdit] = useState(false);
    const [currentValue, setCurrentValue] = useState(value);
    const firstRender = useRef(true);
    useEffect(()=>{
        if(firstRender.current){
            firstRender.current = false;
            return;
        }
        if(!isEdit){
            const func = async()=>{
                const res = await updateDataComplex(currentWebsite.id, currentWebsite.settings.clients, currentUser._id, updateParam, currentValue, "settings.clients");
                if(res){
                    setToastMessage(messagesOptions.ok);
                    setCurrentUser({...currentUser, [updateParam]: currentValue})
                }
                else setToastMessage(messagesOptions.failed);
            }
            func();
        }
    },[isEdit])
    return (
        <div className='profilePage_detailsContainer'>
            <img style={{width:"15px", height:"15px", cursor:"pointer"}} src={media.pencil_icon} alt='profilePage_detailsDiv_edit' onClick={()=>{setIsEdit(!isEdit)}}/>
            <label htmlFor={id}>{label}:</label>
            {isEdit ? <input id={id} onKeyDown={(e)=>{if(e.key==="Enter"){setIsEdit(false)}}} type='text' placeholder={value} onChange={(e)=>{setCurrentValue(e.target.value)}}/> : <p>{value}</p>}
        </div>
    )
}
